export function normalizeNumber(
  number: number,
  maxLimit: number,
  minLimit?: number,
) {
  const _minLimit = minLimit ?? -maxLimit;
  return number > maxLimit ? maxLimit : number < _minLimit ? _minLimit : number;
}
